export {};

declare global {
  interface Array<T> {
    toSpliced(start: number, deleteCount: number, ...items: T[]): T[];
  }

  interface Object {
    groupBy<K extends PropertyKey, T>(items: Iterable<T>, keySelector: (item: T, index: number) => K): Partial<Record<K, T[]>>;
  }
}

if (!Array.prototype.toSpliced) {
  Array.prototype.toSpliced = function <T>(this: T[], start: number, deleteCount: number, ...items: T[]): T[] {
    const result = [...this];
    result.splice(start, deleteCount, ...items);
    return result;
  };
}

if (!Object.groupBy) {
  Object.groupBy = function <K extends PropertyKey, T>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K
  ): Partial<Record<K, T[]>> {
    const result: Partial<Record<K, T[]>> = {};
    let index = 0;
    for (const item of items) {
      const key = keySelector(item, index);
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      index++;
    }
    return result;
  };
}
